/**
 * Move date filters and sort controls for the Quotes list.
 */

import React from "react";
import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import {
  MOVE_DATE_FILTER_LABELS,
  MOVE_DATE_FILTER_OPTIONS,
  QUOTE_SORT_LABELS,
  QUOTE_SORT_OPTIONS,
} from "../utils/moveDateUtils";

const MOVE_DATE_FILTERS = Object.values(MOVE_DATE_FILTER_OPTIONS);
const SORT_OPTIONS = Object.values(QUOTE_SORT_OPTIONS);

export default function QuoteListFilters({
  moveDateFilter = MOVE_DATE_FILTER_OPTIONS.ALL,
  onMoveDateFilterChange,
  sort = QUOTE_SORT_OPTIONS.NEWEST,
  onSortChange,
  resultCount = 0,
  totalCount = 0,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
        mb: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
        Move date
      </Typography>

      {MOVE_DATE_FILTERS.map((value) => (
        <Chip
          key={value}
          label={MOVE_DATE_FILTER_LABELS[value]}
          clickable
          color={moveDateFilter === value ? "primary" : "default"}
          variant={moveDateFilter === value ? "filled" : "outlined"}
          onClick={() => onMoveDateFilterChange?.(value)}
          size="small"
        />
      ))}

      <FormControl size="small" sx={{ ml: { sm: "auto" }, minWidth: 190 }}>
        <InputLabel id="quote-sort-label">Sort</InputLabel>
        <Select
          labelId="quote-sort-label"
          value={sort}
          label="Sort"
          onChange={(event) => onSortChange?.(event.target.value)}
        >
          {SORT_OPTIONS.map((value) => (
            <MenuItem key={value} value={value}>
              {QUOTE_SORT_LABELS[value]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {resultCount !== totalCount && (
        <Typography variant="caption" color="text.secondary" sx={{ width: "100%" }}>
          Showing {resultCount} of {totalCount} quotes
        </Typography>
      )}
    </Box>
  );
}
